


























































import moment from 'moment';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Other as mainTerms } from '@/const/terms/mainTerms';

import { DayReportType, DayDataType } from '@/pages/report/ai/types';
import { ORIGIN_FORMAT } from '@/utils';
@Component<CalendarForAI>({
    name: 'CalendarforAI',
})
export default class CalendarForAI extends Vue {
    @Prop({ type: Date, default: () => new Date() }) private date!: Date;
    @Prop({ type: Array, default: () => [mainTerms.request, mainTerms.impression, mainTerms.impRate] }) private showOption!: string[];
    @Prop({ type: Boolean, default: false}) private loading!: boolean;
    private mainTerms = mainTerms;
    private doLoading: boolean = false;

    private dayHeaders: string[] = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    private days: DayReportType = [];
    private calendarSize: number = 7 * 6;
    
    private targetDate: Date = this.date;

    private reportData: DayDataType = {};
    private expectedData: DayDataType = {};

    private NumberFormat: (param: any) => string = (param: any) => {
        const num = Number.parseFloat(param);
        if (Number.isNaN(num) || num === -1 ) {
            return ' - ';
        }
        return ORIGIN_FORMAT.NumberFormatOrigin(num);
    };

    @Watch('doLoading')
    private loadingHandle(val: boolean) {
        this.doLoading = val;
        this.$emit('update:loading', val);
    }
    @Watch('date')
    private refresh(val: Date, oldVal: Date) {
        this.date = val;
        this.targetDate = val;
        if (val) {
            this.setDayDataHandler();
        }
    }

    private setDayDataHandler() {
        this.doLoading = true;
        const result: DayReportType = [];
        const now = new Date();
        const tomorrow = new Date(now);
        const beginDate = new Date(this.targetDate);
        const endDate = new Date(beginDate);
        tomorrow.setDate(tomorrow.getDate() + 1);
        beginDate.setDate(1);
        beginDate.setDate(beginDate.getDate() - beginDate.getDay());
        endDate.setDate(endDate.getDate() + this.calendarSize - 1);

        this.reportData = {};
        this.expectedData = {};
        setTimeout(() => {
            Promise.all([
                this.getImpRateData(beginDate, now).then((res) => {
                    this.reportData = res as DayDataType;
                }),
                this.getImpRateExpectedData(tomorrow, endDate).then((res) => {
                    this.expectedData = res as DayDataType;
                })
            ]).then(() => { this.setDayData(beginDate, endDate, now) })
        }, 2000);
    }
    private setDayData(begin: Date, end: Date, today: Date) {
        let calendarSize = this.calendarSize;
        const data = {
            ...this.reportData,
            ...this.expectedData,
        };
        this.days = [];
        const beginDate = new Date(begin);
        const endDate = new Date(end);
        const now = new Date(today);
        while (calendarSize-- > 0) {
            const d = new Date(beginDate);

            let dateClass: number = 0;
            if (d.getDay() === 6) dateClass = 1 << 0;
            else if (d.getDay() === 0) dateClass = 1 << 1;

            if (d.getMonth() !== this.targetDate.getMonth()) dateClass += 1 << 2;
            if (d.getTime() < now.getTime()) dateClass += 1 << 4;  // past

            if (d.getMonth() === now.getMonth() && d.getDate() === now.getDate()) {
                dateClass += 1 << 3;// today
            }

            const key: string = moment(d).format('YYYY-MM-DD');
            const request = data && data[key] ? data[key].request : -1;
            const impression = data && data[key] ? data[key].impression : -1;
            const impRate = data && data[key] ? data[key].impRate : -1;

            this.days.push({
                time: d.getTime(),
                Date: d,
                date: d.getDate().toString(),
                dateClass: dateClass,
                request: request,
                impression: impression,
                impRate: impRate,
            })
            beginDate.setDate(beginDate.getDate() + 1);
        }
        this.doLoading = false;
    }

    private getImpRateData = (begin: Date, end: Date) => {
        const result: DayDataType = {};
        for (let d = new Date(begin); d <= end; d.setDate(d.getDate() + 1)) {
            const request = d.getDate();
            const impression = d.getDay();
            const impRate = request === 0 ? -1 : (impression / request) * 100;
            result[moment(d).format('YYYY-MM-DD')] = {
                request: request,
                impression: impression,
                impRate: impRate,
            };
        }
        return Promise.resolve(result);
    }
    private getImpRateExpectedData = (begin: Date, end: Date) => {
        const result: DayDataType = {};
        for (let d = new Date(begin); d <= end; d.setDate(d.getDate() + 1)) {
            const request = d.getDate();
            const impression = d.getDay();
            const impRate = request === 0 ? -1 : (impression / request) * 100;
            result[moment(d).format('YYYY-MM-DD')] = {
                request: request,
                impression: impression,
                impRate: impRate,
            };
        }
        return Promise.resolve(result);
    }
    private created() {
        this.setDayDataHandler();
    }
}
